import * as cookie from 'cookie';
import {
  EMPTY_UTM,
  UTM_COOKIE,
  UTM_COOKIE_MAX_AGE_SECONDS,
  type UtmAttribution,
  parseUtmCookie,
  readUtmFromSearch,
} from 'utils/shared/attribution';

/** Saves the landing URL's campaign tags; a later tagged visit replaces them (last touch). */
export const captureUtmFromUrl = (search = window.location.search) => {
  const attribution = readUtmFromSearch(search);
  if (!attribution) return null;

  document.cookie = cookie.serialize(UTM_COOKIE, JSON.stringify(attribution), {
    maxAge: UTM_COOKIE_MAX_AGE_SECONDS,
    path: '/',
    sameSite: 'lax',
    secure: window.location.protocol === 'https:',
  });
  return attribution;
};

export const getUtmAttribution = (): UtmAttribution | null =>
  typeof document === 'undefined'
    ? null
    : parseUtmCookie(cookie.parse(document.cookie)[UTM_COOKIE]);

/** Spread into a signup request's variables. */
export const getUtmAttributionVariables = (): UtmAttribution => getUtmAttribution() ?? EMPTY_UTM;
